import { Account, Product } from '../swagger';

/**
 * Where to send a coinsured person once they have completed their health
 * declaration: straight to their policy if they have exactly one, otherwise to
 * the portal if they are insured at all, and nowhere if neither applies (they
 * stay on the quiz page).
 *
 * Extracted from Coinsurance so the decision can be tested. It used to be
 * inline, and referenced `Product` without importing it -- a ReferenceError
 * that only fired on the second branch, inside a `.then()`, where it surfaced
 * as an unhandled rejection and a redirect that silently never happened.
 */
export const nextPageAfterQuiz = (
  account: Account | undefined,
  mina: string,
): string | undefined => {
  const orders = account?.orders;

  if (orders?.length === 1) {
    return `${mina}/order-${orders[0].id}`;
  }

  const isInsured = account?.products?.some((product) =>
    [Product.StatusEnum.Inactive, Product.StatusEnum.Active].includes(
      product.status,
    ),
  );

  return isInsured ? mina : undefined;
};
